var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { I18n } from "aws-amplify";
import { I18nAmplifyAuthTranslationsNL, I18nMaryTranslationsNL } from "./nl/I18n";
export var I18nLanguage;
(function (I18nLanguage) {
    I18nLanguage["ENGLISH"] = "en";
    I18nLanguage["DUTCH"] = "nl";
})(I18nLanguage || (I18nLanguage = {}));
export var I18nMarylocales = [I18nLanguage.ENGLISH, I18nLanguage.DUTCH];
export var I18nMaryTranslations = {
    nl: __assign(__assign({}, I18nAmplifyAuthTranslationsNL), I18nMaryTranslationsNL),
};
export var getText = function (key, dflt, vars) {
    var props = {
        key: typeof key === "string" ? key : key.key,
        dflt: typeof key === "string" ? dflt : key.dflt,
        vars: typeof key === "string" ? vars : key.vars,
    };
    var value = I18n.get(props.key, props.dflt);
    if (props.vars && value) {
        Object.keys(props.vars).forEach(function (k) {
            if (value) {
                value = value.replace("{{".concat(k, "}}"), props.vars ? props.vars[k] : "");
            }
        });
    }
    return value;
};
